import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { getActiveOrganizations } from '../mission/utils/getActiveOrganizations';
export function authorizeManageMissionByMissionId(context, userState, missionId) {
    if (requireAnySystemPermission(userState, 'manage-missions')) {
        return true;
    }
    if (!requireAnySystemPermission(userState, 'manage-all-admin-missions')) {
        return false;
    }
    const missionStorage = context.storage('missions');
    const mission = missionStorage.get(missionId);
    return authorizeManageMissionByManageOrgPermission(userState, mission.data.typeId, mission.data.organizationSharing);
}
export function authorizeManageMissionByManageOrgPermission(userState, missionTypeId, missionOrganizationSharing = []) {
    const activeOrganizationIds = getActiveOrganizations(userState);
    const userCanSeeSomeMissionsByType = userState.authorizedMissionTypeIds.length > 0;
    return (requireAnySystemPermission(userState, 'manage-missions') ||
        (requireAnySystemPermission(userState, 'manage-all-admin-missions') &&
            userCanSeeSomeMissionsByType &&
            missionTypeId &&
            userState.authorizedMissionTypeIds.includes(missionTypeId) &&
            missionOrganizationSharing !== 'public' &&
            missionOrganizationSharing.some((id) => activeOrganizationIds.includes(id) && requireAnyOrgPermission(userState, id, 'manage-organization', 'manage-members'))));
}
export function authorizeManageMissionClassifiers(userState) {
    return requireAnySystemPermission(userState, 'manage-mission-classifiers');
}
